import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { Quote, QuoteDeliveryInput, QuoteGlobalDiscount, QuoteItem } from '../types/quote.type';
import { QUOTES_API_PATHS } from '../constants/quotes-paths.constants';

export type UpdateQuoteInput = {
  items?: QuoteItem[];
  delivery?: QuoteDeliveryInput;
  validUntil?: string;
  globalDiscount?: QuoteGlobalDiscount;
  conditions?: string;
  ownerId?: string;
};

type UpdateQuoteParams = {
  id: string;
  data: UpdateQuoteInput;
};

type UseUpdateQuoteResult = {
  updateQuote: (params: UpdateQuoteParams) => Promise<Quote | null>;
  isSubmitting: boolean;
};

export function useUpdateQuote(): UseUpdateQuoteResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateQuote = async ({ id, data }: UpdateQuoteParams): Promise<Quote | null> => {
    setIsSubmitting(true);

    try {
      const updatedQuote = await HttpClient.patch<Quote>(QUOTES_API_PATHS.UPDATE(id), data);

      enqueueSnackbar('Devis modifié', { variant: 'success' });
      return updatedQuote;
    } catch (error) {
      enqueueSnackbar(
        extractApiErrorMessage(error, 'Une erreur est survenue lors de la modification du devis'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { updateQuote, isSubmitting };
}
